import { Directive, ElementRef, inject, Input, OnInit } from "@angular/core";
import { ProductService } from "src/app/services/product.service";
import { PdfService } from "src/app/services/pdf.service";

@Directive({
  selector: "[pdfPreviewFromUrl]",
  standalone: false
})
export class PdfPreviewFromUrlDirective implements OnInit {
  @Input() pdfPreviewFromUrl!: string;
  @Input() fileName!: string;

  private pdfService = inject(PdfService);

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private productService: ProductService
  ) {}

  ngOnInit(): void {
    this.pdfService.attachPdfUrlToElement(
      this.elementRef.nativeElement,
      this.pdfPreviewFromUrl,
      this.fileName
    );
  }

  previewFile(url: string, fileName: string): void {
    this.pdfService.attachPdfUrlToElement(
      this.elementRef.nativeElement,
      this.pdfPreviewFromUrl,
      this.fileName
    );
  }
}
